module.exports = __webpack_public_path__ + "img/BR.238fc318.svg";